import useFilterActions from "../../hooks/useFilterActions";
import { useAISummaryStore } from "../../store/aiSummaryStore";

import Chip from "./Chip";

export default function ChipList() {
  const { chipData } = useAISummaryStore();
  const { handleDeleteChip } = useFilterActions();

  return (
    chipData && chipData.length > 0 && (
    <div className="flex flex-row flex-wrap gap-2">
      {
        chipData.map((chip, index) => (
          <Chip key={index} chip={chip} handleDelete={handleDeleteChip} />
        ))}
    </div>)
  );
}
